import React from 'react'

function IndustriesBreadcrumb() {
    return (
        <div className="about-page-breadcrumb">
            <div className="container">
                <h1 className="about-page-breadcrumb__title">Industries</h1>
            </div>
        </div>
    )
}

export default IndustriesBreadcrumb
